import fetch from '@/utils/fetch'

export const goodsList = '/crm/register/setting/lists_item'
export const shopList = '/crm/register/setting/lists_distributor'
export const welcomeList = '/crm/register/template/lists'

/** 删除商品或店铺 */
export function batchDelete(data) {
  return fetch({
    url: `/crm/register/setting/delete`,
    method: 'post',
    data
  })
}

// 是否开启购买注册
export function registerItem(data) {
  return fetch({
    url: `/crm/register/setting/update/item_open_status`,
    method: 'post',
    data
  })
}

// 是否开启Towmship购买注册
export function registerDistributor(data) {
  return fetch({
    url: `/crm/register/setting/update/distributor_open_status`,
    method: 'post',
    data
  })
}

// 添加注册欢迎语
export function registerCreate(data) {
  return fetch({
    url: `/crm/register/template/create`,
    method: 'post',
    data
  })
}

// 修改注册欢迎语
export function registerUpdate(data) {
  return fetch({
    url: `/crm/register/template/update`,
    method: 'post',
    data
  })
}

// 删除欢迎语
export function registerDelete(data) {
  return fetch({
    url: `/crm/register/template/delete`,
    method: 'post',
    data
  })
}

// 添加注册设置商品或店铺
export function registerSettingCreate(data) {
  return fetch({
    url: `/crm/register/setting/create`,
    method: 'post',
    data
  })
}

// 获取注册欢迎语详情
export function registerTemplateInfo(params) {
  return fetch({
    url: `/crm/register/template/info`,
    method: 'get',
    params
  })
}













